import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { WarehouseCode } from '../interfaces/warehousecode.interface';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WarehousecodeService {

  private getwarehousecodesUrl = environment.apiUrl + '/handlers/warehousecodegetall.php';
  warehousecodes: WarehouseCode[] = [];

  constructor(private http: HttpClient) { }

  async getWarehousecodes(event?: Event): Promise<WarehouseCode[]> {
    let cuser = localStorage.getItem('currentUser');
    if (cuser === null) {
      throw new Error('Not logged in');
    }
    let user = JSON.parse(cuser);
    let distid = user['distid'];
    const data$ = this.http.post<WarehouseCode[]>(this.getwarehousecodesUrl,JSON.stringify({ distid: distid }))
    try {
          if (event) {
            event.preventDefault();
          }
          this.warehousecodes = await firstValueFrom(data$);
          return this.warehousecodes;
        }
        catch (error) {
          console.error('There was an error!', error);
          throw error;
        };  
  }
    
}
